import { render } from "./HumanBrightSvg.vue?vue&type=template&id=207a2742"
import script from "./HumanBrightSvg.vue?vue&type=script&lang=js"
export * from "./HumanBrightSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__